let branchLinksArr = document.querySelectorAll('.jsBranchLink');

// Open dialog
function handleBranchLinkClick(event, el)
{
	event.preventDefault();
	let branchUrl = el.href;
	let confirmationDialog = document.querySelector(`#${el.dataset.dialogId}`);

	// Update link URL in dialog
	confirmationDialog.querySelector('.jsLeaveSiteLink').href = branchUrl;

	// Open dialog
	confirmationDialog.showModal();
}

// Listen for clicks
branchLinksArr.forEach(branchLink =>
{
	branchLink.addEventListener('click', (event) => handleBranchLinkClick(event, branchLink));
});